import fr from 'element-ui/lib/locale/lang/fr';

export default {
  ...fr,

  hanshow: 'Hanshow',
  'no data': 'Pas de données',
  'confirm': 'OK',
  'cancel': 'Annuler',
  'select all': 'tout sélectionner',
  hs: {
    'button': {
      'search': 'recherche',
      'reset': 'réinitialiser',
      'close': 'ranger',
      'open': 'développer',
    },
  },
}